import { InstitutionEnum } from "../institution/enums";

export enum PartnerSsoType {
  MONLY = "MONLY",
  ALLIANZ = "ALLIANZ",
  AXA = "AXA",
  CSOB = "CSOB",
  EUCS = "EUCS",
  FINGO = "FINGO",
  GENERALI = "GENERALI",
  IAD = "IAD",
  LUNA = "LUNA",
  METLIFE = "METLIFE",
  NN_EXPERT_APP = "NN_EXPERT_APP",
  NN_WEB_AGENT_APP = "NN_WEB_AGENT_APP",
  NSURE = "NSURE",
  UNIQA = "UNIQA",
  VZDY_VIAC = "VZDY_VIAC",
  YOUPLUS = "YOUPLUS",
}

export enum PartnerSsoSubType {
  FINGO_PARTNER_SSO = "FINGO_PARTNER_SSO",
  FINGO_ADMIN = "FINGO_ADMIN",
  FINGO_HELPER = "FINGO_HELPER",
  FINGO_NON_LIFE_CALC = "FINGO_NON_LIFE_CALC",
  FINGO_LIFE_CALC = "FINGO_LIFE_CALC",
  FINGO_LOAN_CALC = "FINGO_LOAN_CALC",
  FINGO_INVEST_CALC = "FINGO_INVEST_CALC",
}

export const ssoTypeToInstitutionMap = new Map<PartnerSsoType, InstitutionEnum>([
  [PartnerSsoType.ALLIANZ, InstitutionEnum.ALLIANZ],
  [PartnerSsoType.AXA, InstitutionEnum.AXA_NON_LIFE],
  [PartnerSsoType.CSOB, InstitutionEnum.CSOB],
  [PartnerSsoType.GENERALI, InstitutionEnum.GENERALI],
  [PartnerSsoType.IAD, InstitutionEnum.IAD],
  [PartnerSsoType.METLIFE, InstitutionEnum.MET_LIFE],
  [PartnerSsoType.NN_EXPERT_APP, InstitutionEnum.NN],
  [PartnerSsoType.NN_WEB_AGENT_APP, InstitutionEnum.NN],
  [PartnerSsoType.UNIQA, InstitutionEnum.UNIQA],
  [PartnerSsoType.YOUPLUS, InstitutionEnum.YOUPLUS],
]);
